import React from 'react';
import styled from 'styled-components';

interface Props {
  name?: string;
  onClick: () => void;
}

export const LoginButton: React.FC<Props> = ({ name = 'Вхід та реєстрація', onClick }) => {
  return <ButtonS onClick={onClick}>{name}</ButtonS>;
};

export const ButtonS = styled.button`
  color: #fff;
  background-color: #212529;
  border-color: #212529;
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 16px;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
`;
